<template>
    <div class="application-container">
        <div class="section-header">
            <h2>{{ lang.industryApplications }}</h2>
            <div class="underline"></div>
        </div>

        <div class="application-grid">
            <div class="application-card">
                <div class="card-image">
                    <img src="images/banner1-2.jpg" alt="" />
                    <div class="overlay">
                        <i class="el-icon-view"></i>
                        <span>{{ lang.applicationPage.title1 }}</span>
                    </div>
                </div>
                <div class="card-content">
                    <h4>{{ lang.applicationPage.title1 }}</h4>
                    <el-popover
                        placement="bottom"
                        width="500"
                        trigger="hover"
                        effect="dark"
                        popper-class="des-popper"
                        :content="lang.applicationPage.description1"
                    >
                        <p class="description" slot="reference">
                            {{ lang.applicationPage.description1 }}
                        </p>
                    </el-popover>
                </div>
            </div>

            <div class="application-card">
                <div class="card-image">
                    <img src="images/banner4.jpg" alt="" />
                    <div class="overlay">
                        <i class="el-icon-view"></i>
                        <span>{{ lang.applicationPage.title2 }}</span>
                    </div>
                </div>
                <div class="card-content">
                    <h4>{{ lang.applicationPage.title2 }}</h4>
                    <el-popover
                        placement="bottom"
                        width="500"
                        trigger="hover"
                        effect="dark"
                        popper-class="des-popper"
                        :content="lang.applicationPage.description2"
                    >
                        <p class="description" slot="reference">
                            {{ lang.applicationPage.description2 }}
                        </p>
                    </el-popover>
                </div>
            </div>

            <div class="application-card">
                <div class="card-image">
                    <img src="images/banner3-2.jpg" alt="" />
                    <div class="overlay">
                        <i class="el-icon-view"></i>
                        <span>{{ lang.applicationPage.title3 }}</span>
                    </div>
                </div>
                <div class="card-content">
                    <h4>{{ lang.applicationPage.title3 }}</h4>
                    <el-popover
                        placement="bottom"
                        width="500"
                        trigger="hover"
                        effect="dark"
                        popper-class="des-popper"
                        :content="lang.applicationPage.description3"
                    >
                        <p class="description" slot="reference">
                            {{ lang.applicationPage.description3 }}
                        </p>
                    </el-popover>
                </div>
            </div>

            <div class="application-card">
                <div class="card-image">
                    <img src="images/banner-4-2.jpg" alt="" />
                    <div class="overlay">
                        <i class="el-icon-view"></i>
                        <span>{{ lang.applicationPage.title4 }}</span>
                    </div>
                </div>
                <div class="card-content">
                    <h4>{{ lang.applicationPage.title4 }}</h4>
                    <el-popover
                        placement="bottom"
                        width="500"
                        trigger="hover"
                        effect="dark"
                        popper-class="des-popper"
                        :content="lang.applicationPage.description4"
                    >
                        <p class="description" slot="reference">
                            {{ lang.applicationPage.description4 }}
                        </p>
                    </el-popover>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    mixins: [],
    name: "applicationPage",
    components: {},
    computed: {
        lang() {
            return this.$store.state.language;
        },
    },
    data() {
        return {};
    },
    created() {},
    async beforeMount() {},
    mounted() {},
    methods: {},
};
</script>
<style lang="scss" scoped>
.application-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 40px 20px;

    .section-header {
        text-align: center;
        margin-bottom: 50px;
        
        h2 {
            font-size: 2.2rem;
            font-weight: 600;
            color: #2c3e50;
            margin-bottom: 15px;
        }
        
        .underline {
            width: 80px;
            height: 3px;
            background: linear-gradient(to right, #3498db, #2980b9);
            margin: 0 auto;
        }
    }

    .application-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(480px, 1fr));
        gap: 30px;
        
        .application-card {
            background: #fff;
            border-radius: 10px;
            overflow: hidden;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
            transition: all 0.3s ease;
            height: 100%;
            
            &:hover {
                transform: translateY(-10px);
                box-shadow: 0 15px 30px rgba(0, 0, 0, 0.12);
                
                .card-image {
                    .overlay {
                        opacity: 1;
                        
                        i, span {
                            transform: translateY(0);
                        }
                    }
                    
                    img {
                        transform: scale(1.05);
                    }
                }
            }
            
            .card-image {
                position: relative;
                height: 240px;
                overflow: hidden;
                
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    transition: transform 0.5s ease;
                }
                
                .overlay {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: rgba(0, 0, 0, 0.5);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    opacity: 0;
                    transition: opacity 0.3s ease;
                    
                    i {
                        color: white;
                        font-size: 36px;
                        margin-bottom: 15px;
                        transform: translateY(-10px);
                        transition: transform 0.3s ease;
                    }
                    
                    span {
                        color: white;
                        font-size: 1.5rem;
                        font-weight: 600;
                        text-align: center;
                        padding: 0 20px;
                        transform: translateY(10px);
                        transition: transform 0.3s ease;
                    }
                }
            }
            
            .card-content {
                padding: 25px;
                
                h4 {
                    font-size: 1.3rem;
                    font-weight: 600;
                    color: #2c3e50;
                    margin-bottom: 15px;
                }
                
                .description {
                    color: #555;
                    font-size: 1rem;
                    line-height: 1.6;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 3;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }
    }
    
    @media (max-width: 992px) {
        .application-grid {
            grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
        }
    }
    
    @media (max-width: 768px) {
        padding: 30px 15px;
        
        .section-header {
            margin-bottom: 30px;
            
            h2 {
                font-size: 1.8rem;
            }
        }
        
        .application-grid {
            grid-template-columns: 1fr;
            gap: 25px;
            
            .application-card {
                .card-image {
                    height: 200px;
                }
                
                .card-content {
                    padding: 20px;
                    
                    h4 {
                        font-size: 1.2rem;
                    }
                }
            }
        }
    }
}
</style>
<style>
@media (max-width: 768px) {
    .des-popper {
        width: 300px !important;
    }
}
</style>
